// extracted by mini-css-extract-plugin
module.exports = {"detail":"detail_detail_3ywU5","listWrap":"detail_listWrap_NMhFL"};